<!--
  auth: 周许旺
 -->
<template>
  <div class="page-set-add">
    <div v-if="isF">
      <el-input
        :class="!showThousand ? 'show-input' : 'hide-input'"
        v-bind="{ ...$props}"
        :placeholder="placeholder"
        type="text"
        ref="numberInput"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
      ></el-input>
      <div v-if="disabled" :class="showThousand ? 'show-div disable-color' : 'hide-div'" @click="showInput($event)">
        {{showMoney}}
      </div>
      <div v-else :class="showThousand ? 'show-div' : 'hide-div'" @click="showInput($event)">{{showMoney}}</div>
    </div>
    <div v-else>
      <el-input
        v-bind="{ ...$props}"
        type="text"
        @input="handleInput"
        :placeholder="placeholder"
      ></el-input>
    </div>
  </div>
</template>

<script>
  import {moneyFormat} from '../utils.js'
  import Store from '../../../../utils/catch-state'
  import projectInfo from '../../../../utils/project-info'
  export default {
    name: 'thousands-input',
    props: {
      value: {
        type: String
      },
      fieldType: String,  //是数字类型还是金额类型
      negative: { // 是否允许输入负数
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请输入'
      },
      // 组件大小
      size: {
        type: String,
        default: 'small'
      }
    },
    model: {
      prop: 'value',
      event: '_changeVal'
    },
    computed: {
      isF () {
        return (this.systemRules.numberThousandthPercentileEnabled && this.fieldType.includes('number')) || (this.systemRules.priceThousandthPercentileEnabled && this.fieldType.includes('currency'))
      }
    },
    watch: {
      value (newVal) {
        if (this.isF) {
          this.showMoney = moneyFormat(newVal)
        }
      }
    },
    data () {
      return {
        showMoney: this.value,
        systemRules: {
          priceThousandthPercentileEnabled: true, // 金额组件是否千分位展示
          numberThousandthPercentileEnabled: true // 数字是否是千分位展示
        },
        showThousand: false  // 失去焦点展示千分位开关
      }
    },
    created () {
      this.getSystemRules()
      if (this.isF && this.value) {
        this.showMoney = moneyFormat(this.value)
        this.showThousand = true
      }
    },
    methods: {
      handleFocus (e) {
        if (this.systemRules.numberThousandthPercentileEnabled || this.systemRules.priceThousandthPercentileEnabled) {
          e.target.selectionStart = e.target.value.length
          e.target.selectionEnd = e.target.value.length
        }
      },
      handleInput (value) {
        // eslint-disable-next-line no-useless-escape
        const reg = /[\u4e00-\u9fa5a-z_A-Z!@#\$%\\\^&\*\)\(\+=\{\}\[\]\/",'<>~\`\?:;|]+$/g
        const regexp = /[^\-\d^\\.]+/g
        let payAmount = value.replace(reg, '').replace(regexp, '')
        if (payAmount.slice(0, 1) === '-') {
          payAmount = '-' + payAmount.replace(/-/g, '')
        } else {
          payAmount = payAmount.replace(/-/g, '')
        }
        this.value = payAmount
        this.$emit('_changeVal', payAmount)
        this.$emit('input', payAmount)
      },
      handleBlur (e) {
        if (this.systemRules.numberThousandthPercentileEnabled || this.systemRules.priceThousandthPercentileEnabled) {
          if (e.target.value) {
            this.showMoney = moneyFormat(this.value)
            this.showThousand = true
          }
        }
      },
      showInput () {
        if (this.disabled) {
          return false
        }
        let input = this.$refs.numberInput
        this.showThousand = false
        input.focus()
      },
      async getSystemRules () {
        const project = projectInfo.query()
        if (project === 'sur') {
          const res = await Store.thousandthsConversion('getSystemRule').getter()
          this.systemRules.priceThousandthPercentileEnabled = res['amount_unit_price_thousands_config'] === '0'
          this.systemRules.numberThousandthPercentileEnabled = res['number_thousands_config'] === '0'
        } else {
          const res = await Store.thousandthsConversion('getSystemRules').getter()
          this.systemRules.priceThousandthPercentileEnabled = res['amount_unit_price_thousands_config'].value === '0'
          this.systemRules.numberThousandthPercentileEnabled = res['number_thousands_config'].value === '0'
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .el-form {
    .el-input, .el-select {
      width: 100%;
    }
  }

  .is-required .show-div {
    background: #FFFDEF !important;
  }

  .page-set-add {
    position: relative;

    .show-div {
      display: flex;
      align-items: center;
      width: calc(100% - 13px);
      height: calc(100% - 2px);
      position: absolute;
      top: 0;
      left: 0;
      border: 1px solid #ddd;
      border-radius: 5px;
      padding-left: 11px;
      font-size: 12px;
      color: #303030;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      background: #fff;
    }

    .disable-color {
      background: #fafafa;
      cursor: pointer;
      color: #c0c4cc;
    }

    .hide-div {
      display: none;
    }

    .show-input {
      opacity: 1;
    }

    .hide-input {
      opacity: 0;
    }
  }

</style>
